// extracted by mini-css-extract-plugin
module.exports = {"letters":"Letters_letters__1xW-5","letters__footer-line":"Letters_letters__footer-line__2Ps6-","light":"Letters_light__3WBII","dark":"Letters_dark__1yXkc"};